export function getDate () {
    const date = new Date()
    const year:any = date.getFullYear();
    let month:any = date.getMonth() + 1;
    let day:any = date.getDate();
    month = (month > 9) ? month : ("0" + month);
    day = (day < 10) ? ("0" + day) : day;
    const today = year + '-' +  month + '-' + day;
    return today
}